import React, { Component } from 'react';
import {Dialog, Card, CardMedia, IconButton, DialogTitle, withStyles, WithStyles} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { DialogTop } from '@components/economy/DialogComponens';
import { GiphyStyles } from './Giphy.style';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';

const tn: TranslateNew = TranslateNew.getInstance();


interface IProps extends WithStyles<typeof GiphyStyles> {
    onGifSelect: (gifUrl: string) => void;
    isOpen: boolean; 
    onClose: () => void;
}

interface IState {
    query: string;
    gifs: IGiphyGif[];
}

interface IGiphyGif {
    id: string;
    title: string;
    images: {
        fixed_width: {
            url: string;
        };
        original: {
            url: string;
        };
    };
}

class Giphy extends Component<IProps, IState>  {
    private readonly API_KEY = process.env.REACT_APP_GIPHY_API_KEY || '';
    private readonly API_URL = 'https://api.giphy.com/v1/gifs/search';

    constructor(props: IProps) {
        super(props);

        this.state = {
            query: '',
            gifs: [],
        };
    }

    public resetState = () => {
        this.setState({
            query: '',
            gifs: [],
        });
    };


    public render() {
        const { gifs, query } = this.state;
        const {isOpen, onClose, onGifSelect,classes} = this.props;

        return (
            <Dialog open={isOpen} onClose={onClose}>
                <DialogTop>
                  <DialogTitle>{tn.lang.chatGifSearch}</DialogTitle>
                  <IconButton onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </DialogTop>
                <div className={classes.container}>
                  {/* Sökfält */}
                  <div className={classes.searchContainer}>
                    <input
                      className={classes.greyInput}
                      placeholder={tn.lang.chatGifSearch}
                      value={query}
                      onChange={(e) => this.setState({ query: e.target.value })}
                    />
                    <Button disabled={!this.state.query} variant="contained" color="primary" onClick={this.searchGifs}>
                      {tn.lang.search}
                    </Button>
                  </div>
                  {/* GIF-resultat */}
                  <div style={{display:'flex', gap:'10px'}}>
                    <div className={classes.gifContainer}>
                      {gifs.map((gif, index) => ((index % 2 === 0) &&
                        <Card
                          key={gif.id}
                          className={classes.gifCard}
                          onClick={() => onGifSelect(gif.images.original.url)}
                        >
                          <CardMedia
                            component="img"
                            image={gif.images.fixed_width.url}
                            alt={gif.title || "Gif"}
                            className={classes.gifMedia}
                          />
                        </Card>
                      ))}
                    </div>
                    <div className={classes.gifContainer}>
                      {gifs.map((gif, index) => ((index % 2 === 1) &&
                        <Card
                          key={gif.id}
                          className={classes.gifCard}
                          onClick={() => onGifSelect(gif.images.original.url)}
                        >
                          <CardMedia
                            component="img"
                            image={gif.images.fixed_width.url}
                            alt={gif.title || "Gif"}
                            className={classes.gifMedia}
                          />
                        </Card>
                      ))}
                    </div>
                  </div>
                </div>
            </Dialog>
        );
    }



   
    public searchGifs = async () => {
        const { query } = this.state;

        if (query.trim().length < 1) {
          return;
        }
        try {
            if (!this.API_KEY) {
                throw new Error('REACT_APP_GIPHY_API_KEY is not configured');
            }

            const response = await fetch(`${this.API_URL}?api_key=${this.API_KEY}&q=${encodeURIComponent(query)}&limit=20`);
            if (!response.ok) throw new Error('Failed to fetch GIFs');

            const { data } = await response.json();
            this.setState({ gifs: data });
        } catch (error) {
            console.error('Error fetching GIFs:', error);
        }
    };

}

export default withStyles(GiphyStyles)(Giphy);



// WEBPACK FOOTER //
// ./src/components/chat/giphy/Giphy.tsx